import { Component, OnInit, Input, ViewChild, OnDestroy, inject } from '@angular/core';
import { Banner } from 'src/app/models/client-configuration';
import { ConfigService } from 'src/app/services/config.service';
import { Subscription } from 'rxjs';
import { LocaleService } from 'src/app/services/locale.service';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit, OnDestroy {
  private readonly analyticsService = inject(AnalyticsService);

  readonly swiperConfig: SwiperOptions = {
    freeMode: false,
    grabCursor: false,
    slidesOffsetAfter: 0,
    observer: true,
    breakpoints: undefined,
    pagination: {
      type: 'bullets',
      clickable: true,
    },
    autoHeight: true,
  };

  @Input()
  banners: Banner[];

  fadedBanner: boolean;

  currentIndex = 0;
  textDirection: string;

  readonly DEFAULT_AUTOPLAY = 3; // in seconds

  constructor(
    configService: ConfigService,
    private localeService: LocaleService
  ) {
    const configSlideTime = configService.get().bannerSlideTime;
    let bannerSlideTime = configSlideTime;

    if (configSlideTime === -1) {
      bannerSlideTime = this.DEFAULT_AUTOPLAY;
    }

    if (bannerSlideTime > 0) {
      this.swiperConfig.autoplay = {
        delay: bannerSlideTime * 1000,
      };
    }

    this.fadedBanner = configService.get().showFadedBanner;

    if (this.fadedBanner) {
      this.swiperConfig.pagination = false;
    }
  }

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();

    this.banners.forEach((b) => {
      if (!this.fadedBanner && (b.title || b.content)) {
        b.showInfo = true;
      }

      b.clickable = Boolean(b.url);
    });

    this.swiperConfig.navigation = {
      enabled: this.banners.length > 1,
    };
  }

  ngOnDestroy() {}

  onActiveIndexChange(swiper) {
    this.currentIndex = swiper.activeIndex;
  }

  bannerButtonClick(banner: Banner) {
    if (!banner.clickable) {
      return;
    }

    this.analyticsService.sendUserActionEvent('tap_banner', true);

    if (banner.url.includes(window.location.origin)) {
      this.analyticsService.searchPerformedOrigin = 'banner';
      window.open(banner.url, '_self');
    } else {
      window.open(banner.url, '_blank', 'noopener');
    }
  }

  isCurrentBanner(banner: Banner) {
    return this.banners[this.currentIndex].id === banner.id;
  }

  handleBulletTabIndex() {
    document
      .querySelectorAll<HTMLElement>('.banner-swiper .swiper-pagination-bullet')
      .forEach((bullet) => (bullet.tabIndex = -1));
  }
}
